import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router, RouterOutlet } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { Button } from 'primeng/button';
import { Drawer } from 'primeng/drawer';
import { filter, fromEvent } from 'rxjs';
import { FullNamePipe } from '../../../shared/pipe/full-name.pipe';
import { ReplaceEmptyAvatarPipe } from '../../../shared/pipe/replace-empty-avatar.pipe';
import { ApplicationSelectors } from '../../../shared/store/application/application.selectors';
import { AuthSelectors } from '../../../shared/store/auth/auth.selectors';
import { TranslateUtil } from '../../../shared/util/translate.util';
import { ApplicationConfig } from '../../config/application.config';
import { MenuComponent } from './container/menu/menu.component';

@Component({
  selector: 'app-main-layout',
  imports: [
    CommonModule,
    RouterOutlet,
    MenuComponent,
    Button,
    Drawer,
    FullNamePipe,
    TranslatePipe,
    ReplaceEmptyAvatarPipe,
  ],
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.scss',
})
export class MainLayoutComponent {
  private translateUtil = inject(TranslateUtil);
  private router = inject(Router);

  public visibleDrawer: boolean = false;

  public store = inject(Store);

  public loggedUser$ = this.store.select(AuthSelectors.getCurrentLogged);
  public featureTitleKey$ = this.store.select(
    ApplicationSelectors.featureTitleKey
  );

  constructor() {
    fromEvent<StorageEvent>(window, 'storage')
      .pipe(
        takeUntilDestroyed(),
        filter(
          (event: StorageEvent) =>
            !!event?.key &&
            event.key === `${ApplicationConfig.applicationName}:auth.account`
        )
      )
      .subscribe((event: StorageEvent) => {
        if (event.newValue === 'null') {
          this.router.navigate(['/auth/login']);
        }
      });
  }
}
